module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), (_vm.showModalEditar) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "materiales_",
      "folder": "curso_virtual_material"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo  deseado")]), _c('i', {
    staticClass: "fa fa-file",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar material")]) : _c('span', [_vm._v("Crear material")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "100",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "textarea w-300",
    attrs: {
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "text-center"
  }, [
    [(_vm.pathDoc) ? _c('div', {
      staticClass: "mb-5 mt-5 adjunto"
    }, [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": _vm.pathDoc,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small"
    })]), _c('span', [_vm._v("Ver adjunto")])]), _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          return _vm.borrarArchivo()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _c('div', [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalAdjuntar
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-upload is-small"
    })]), _c('span', [_vm._v("Adjuntar")])])])]
  ], 2)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": function($event) {
        return _vm.guardar()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)]) : _vm._e(), _vm._m(0), (_vm.modulo !== 'alumno') ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.abrirModalEditar()
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Nuevo")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "information"
  }, [_c('div', {
    staticClass: "is-mobile"
  }, [_c('div', {
    staticClass: "data"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "usuario",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "display-flex aic"
    }, [_c('div', {
      staticClass: "display-flex fdc flex-1"
    }, [(_vm.modulo !== 'alumno') ? _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]) : _c('strong', {
      staticClass: "flex"
    }, [_vm._v(_vm._s(o.titulo))]), (o.descripcion) ? _c('div', {
      staticClass: "subtitle"
    }, [(_vm.modulo !== 'alumno') ? _c('span', {
      staticClass: "italic flex"
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion)))]) : _c('span', {
      staticClass: "italic flex",
      domProps: {
        "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(o.descripcion))
      }
    })]) : _vm._e()]), (o.pathDoc || _vm.modulo !== 'alumno') ? _c('div', {
      staticClass: "contenedor-acciones display-flex aic"
    }, [(o.pathDoc) ? _c('a', {
      staticClass: "button is-small m-2",
      attrs: {
        "href": o.pathDoc,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa is-small",
      class: [_vm.getFileIcon(o.extension).i]
    })])]) : _vm._e(), (_vm.modulo !== 'alumno') ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.abrirModalEditar(o.id)
        }
      }
    }, [_vm._m(3, true)]), _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(4, true)])] : _vm._e()], 2) : _vm._e()])])
  }), 0)]), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(5)]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Materiales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay materiales registradas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee55b0c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_materiales_lista.vue
// module id = 853
// module chunks = 0